function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.6947 92.8909L93.1912 80.8758C89.4437 83.2499 84.6844 84.4953 79.3078 84.4953C69.5612 84.4953 58.3188 79.8082 59.9424 63.7843H71.3348C67.4928 61.5659 64.1735 57.913 64.1735 51.2576C64.1735 41.5944 72.2411 34.8501 83.7836 34.8501C100.03 34.8501 103.511 45.2028 103.077 51.1631H117.922C123.254 51.1631 127.124 53.4372 129.12 57.635C132.984 52.6087 138.388 50.6127 143.77 50.6127C149.153 50.6127 154.89 52.631 158.049 58.0575C161.996 52.5476 167.69 50.6127 173.005 50.6127C177.759 50.6127 181.851 52.0916 184.742 54.8049L214.355 42.812L0 0L54.7604 51.7747L16.452 122.954L90.6947 92.8909Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.629 54.4434L230.94 70.3505L229.144 54.4434H219.103L223.834 78.1234C224.274 80.3363 222.884 80.7422 220.776 80.7422H215.828L214.177 88.6985H220.86C229.856 88.6985 231.635 86.0742 233.943 81.604L247.982 54.4434H237.634H237.629Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M117.928 53.9097C115.114 53.9097 112.907 55.2107 110.928 57.3513L111.534 54.4434H102.015L94.3199 91.4452L105.212 87.0195L107.13 77.9177C108.726 79.9193 111.172 81.2704 114.047 81.2704C121.569 81.2704 127.43 74.4872 127.43 65.4689C127.43 57.9518 123.866 53.9152 117.928 53.9152M117.461 67.5372C116.927 71.1179 114.675 74.0257 112.095 74.0257C109.332 74.0257 108.498 71.0289 109.037 67.4483C109.571 63.8676 111.189 61.0543 113.952 61.0543C116.476 61.0543 118 63.9622 117.466 67.5428",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.765 53.8652C134.346 53.8652 128.686 60.9487 128.686 68.9829C128.686 77.0171 133.557 81.3316 141.063 81.3316C149.414 81.3316 153.673 77.562 155.163 72.836H145.772C145.144 73.9869 144.104 74.9432 141.808 74.9432C139.056 74.9432 137.816 72.8137 137.971 69.8058H156.119C158.488 59.2028 152.061 53.8708 143.765 53.8708M147.246 64.6628H138.639C139.356 61.6548 141.547 60.2481 143.632 60.2481C146.228 60.2481 147.663 61.8828 147.246 64.6628Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.999 53.8652C163.586 53.8652 157.926 60.9487 157.926 68.9829C157.926 77.0171 162.791 81.3316 170.297 81.3316C178.654 81.3316 182.907 77.562 184.397 72.836H175.012C174.384 73.9869 173.344 74.9432 171.053 74.9432C168.301 74.9432 167.056 72.8137 167.206 69.8058H185.359C187.728 59.2028 181.295 53.8708 172.999 53.8708M176.48 64.6628H167.879C168.596 61.6548 170.787 60.2481 172.872 60.2481C175.457 60.2481 176.897 61.8828 176.48 64.6628Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M209.284 48.3776L207.471 57.0568C205.826 55.1664 203.246 53.9098 200.471 53.9098C192.943 53.9098 187.089 60.693 187.089 69.7169C187.089 77.234 190.658 81.2705 196.596 81.2705C199.409 81.2705 201.611 79.9695 203.596 77.8345L202.99 80.7368H212.509L220.165 43.9685L209.29 48.372L209.284 48.3776ZM205.481 67.7375C204.953 71.3181 203.335 74.1315 200.566 74.1315C198.042 74.1315 196.518 71.2292 197.058 67.643C197.586 64.0623 199.838 61.16 202.423 61.16C205.186 61.16 206.015 64.1513 205.481 67.7375Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.6629 49.9345C78.6629 47.7939 80.5144 46.3594 83.6503 46.3594C87.2253 46.3594 89.0546 48.2164 88.6543 51.7748H99.7798C100.336 46.6763 98.2175 38.1028 83.7893 38.1028C73.3253 38.1028 67.4262 43.9741 67.4262 51.2577C67.4262 65.6415 86.4303 61.8551 86.4303 68.149C86.4303 70.4453 85.5129 72.8194 80.3365 72.8194C75.1601 72.8194 74.6597 69.072 74.5763 67.0315H63.0894C62.8336 74.7765 67.9099 81.2428 79.3135 81.2428C89.7774 81.2428 97.8338 75.883 97.8338 66.6923C97.8338 52.5643 78.6629 56.8177 78.6629 49.9289",
  fill: "white"
});

var SvgSpeedyhireLogo = function SvgSpeedyhireLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#1d0575"
    },
    viewBox: "0 0 248 123",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpeedyhireLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speedyhire-logo.bf1fe0a1.svg";
export { ForwardRef as ReactComponent };